import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

import { useThreeDStockShowFiltersLayoutStickyScroll } from './hooks/useThreeDStockShowFiltersLayoutStickyScroll';

interface ThreeDStockShowFiltersLayoutProps {
  children: ReactNode;
  onClose: () => void;
  isModal?: boolean;
}

function ThreeDStockShowFiltersLayout({
  children,
  onClose,
  isModal
}: ThreeDStockShowFiltersLayoutProps) {
  const ref = useRef<HTMLDivElement>(null);

  useThreeDStockShowFiltersLayoutStickyScroll(ref);

  const [showPortal, setShowPortal] = useState(window?.innerWidth < 1024);
  const mainSectionElement = isModal
    ? document?.body
    : document?.getElementById('main-section') || document?.body;

  useEffect(() => {
    const handleResize = () => {
      setShowPortal(window.innerWidth < 1024);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return showPortal ? (
    createPortal(
      <div>
        <div
          id="side-panel-backdrop"
          className={
            isModal
              ? 'absolute inset-0 z-20 bg-gray-200 bg-opacity-30 dark:bg-gray-800 dark:bg-opacity-50 xl:hidden'
              : 'absolute inset-0 bg-gray-200 bg-opacity-30 dark:bg-gray-800 dark:bg-opacity-50 xl:hidden'
          }
          onClick={onClose}
        />

        <div
          id="3d-stock-filters-panel"
          className={
            isModal
              ? 'absolute top-0 left-0 bottom-0 z-20 w-full shrink-0 max-w-80 overflow-y-auto row-span-2 shadow-lg bg-white dark:bg-gray-850 border-r dark:border-gray-700 pb-4'
              : 'absolute top-0 left-0 bottom-0 w-full shrink-0 max-w-80 overflow-y-auto row-span-2 shadow-lg bg-white dark:bg-gray-850 border-r dark:border-gray-700 pb-4'
          }
        >
          {children}
        </div>
      </div>,
      mainSectionElement
    )
  ) : (
    <div
      id="3d-stock-filters-panel"
      ref={ref}
      className="absolute top-0 left-0 bottom-0 w-full shrink-0 max-w-80 lg:max-w-[19rem] lg:-mb-6 lg:sticky lg:top-4 row-span-2 lg:rounded-xl shadow-lg lg:shadow-sm bg-white dark:bg-gray-850 border-r lg:border dark:border-gray-700 overflow-clip"
    >
      {children}
    </div>
  );
}

export default ThreeDStockShowFiltersLayout;
